"use client";

import WhatToChoose from "@/components/index/sections/about/WhatToChoose";
import { useLanguage } from "@/context/LanguageContext";

const About = () => {
  const { language } = useLanguage();
  const copy = {
    cs: {
      label: "Jak vybrat členství",
      title: "Jaký plán je pro mě ten pravý?",
      subtitle:
        "Reálné příklady použití - od vlastníků bytů po profesionální investory.",
    },
    en: {
      label: "How to choose",
      title: "Which plan is right for me?",
      subtitle:
        "Real use cases - from apartment owners to professional investors.",
    },
  }[language];

  return (
    <div className="about-root">
      <div className="section-label">{copy.label}</div>
      <h2 className="section-title">{copy.title}</h2>
      <p className="section-subtitle">{copy.subtitle}</p>
      <WhatToChoose />
    </div>
  );
};

export default About;
